import React, { useEffect, useState } from 'react';
import { pendingCrStatusApi } from '../../services/nmbs-users-api';
import PendingCrSuccess from '../../components/UI/Modal/PendingCrSuccess';

function PendingCrStatus(props) {

    const [apiData, setApiData] = useState(null);

    useEffect(() => {
        async function pendingCrStatusHandler() {
            await pendingCrStatusApi()
            .then((data) => {
                if (data && data > 0) {
                    setApiData(data);
                }
                else{
                    props.setShowUnblockModel();
                }
                    
            })
            .catch((error) => {
                setApiData([]);
                props.setShowUnblockModel();
            })
        }
        if(props.showUnblockModel){
            pendingCrStatusHandler();
        }
    }, []);
    
    return (
        apiData && apiData >0 ? <PendingCrSuccess pendingCrCount={apiData} setShowUnblockModel={props.setShowUnblockModel}/> : null
);
}

export default PendingCrStatus;